import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { ToastProvider } from "react-toast-notifications";

export const Toast = ({ children }) => {

    const { pathname } = useLocation();
    const isGV = pathname.includes("/graphical-viewer");

    return <ToastProvider components={isGV ? {
        ToastContainer: ({ children, ...props }) => {
            return null;
        },
    } : undefined}>
        {children}
    </ToastProvider>;
};